import {
  AfterContentChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TipoAlcanceViewModel } from "src/app/_core/models/centros/centro-list-base.model";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { DecimalService } from "src/app/_core/providers/decimals.service";
import { MasterService } from "src/app/_core/providers/master.service";
import { CentroPageComponent } from "../../../pages/centro/centro.page";

@Component({
    selector: "app-centro-design-data-card",
    templateUrl: "./centro-design-data-card.component.html",
    styleUrls: ["./centro-design-data-card.component.scss"],
    standalone: false
})
export class CentroDesignDataCardComponent
  implements OnInit, AfterContentChecked
{
  @Input() centro!: CentrosViewModel;
  @Input() parent: CentroPageComponent;
  @Output() designFormComplete = new EventEmitter<boolean>();
  @Output() centroDesignData = new EventEmitter<FormGroup>();
  public tipoAlcanceList: TipoAlcanceViewModel[] = [];

  myDesignForm: FormGroup;
  countControls: number = 0;
  countFilled: number = 0;

  constructor(
    private readonly _masterService: MasterService,
    private readonly _translateService: TranslateService,
    public renderer: Renderer2,
    public el: ElementRef,
    private readonly fb: FormBuilder,
    public decimalService: DecimalService
  ) {}

  // Etiqueta de opción para el app-ds-select de alcance.
  alcanceLabelOf = (item: TipoAlcanceViewModel): string =>
    this._translateService.instant("centro.reachTypes." + item.codigo);

  // Modo lectura / edición (gobernado por la página).
  get editing(): boolean {
    return !!(this.parent?.isEditing || this.parent?.isCreating);
  }
  // Código del alcance seleccionado (para resolver su etiqueta en lectura).
  get alcanceCodigo(): string | null {
    const id = this.myDesignForm?.get("alcancePryID")?.value;
    return this.tipoAlcanceList?.find((x) => x.id === id)?.codigo ?? null;
  }

  /** ¿La pestaña tiene algún parámetro aplicable al tipo de instalación? */
  get hasAnyField(): boolean {
    return this.parent?.anyInstFieldVisible([
      "alcanceProyecto",
      "caudalDiseno",
      "numAbonados",
      "kmRedAbas",
      "kmRedSanea",
      "habitantesEquivalentes",
    ]);
  }

  /** ¿El control tiene valor? (para el estado fantasma del tile). */
  has(control: string): boolean {
    const v = this.myDesignForm?.get(control)?.value;
    return v !== null && v !== undefined && v !== "";
  }

  /** Valor numérico formateado al locale del usuario (o "—"). */
  fmt(control: string): string {
    const v = this.myDesignForm?.get(control)?.value;
    if (v === null || v === undefined || v === "") {
      return "—";
    }
    const n = Number(v);
    return Number.isFinite(n)
      ? new Intl.NumberFormat(this.parent?.getUserLocale() ?? "es-ES", {
          maximumFractionDigits: 2,
        }).format(n)
      : `${v}`;
  }

  // Events
  ngOnInit(): void {
    this._loadData();
    this.loadCentroDesignDataFormGroup();
  }

  private _loadData(): void {
    this._masterService.getTipoAlcanceList().subscribe((result) => {
      this.tipoAlcanceList = result;
    });
  }

  ngAfterContentChecked(): void {
    this.getFormStatus();
  }

  loadCentroDesignDataFormGroup() {
    this.myDesignForm = this.fb.group({
      alcancePryID: [this.centro?.alcancePryID],
      caudalDiseno: [this.centro?.caudalDiseno],
      numeroAbonados: [this.centro?.numeroAbonados],
      kmRedAbas: [this.centro?.kmRedAbas],
      kmRedSanea: [this.centro?.kmRedSanea],
      habitantesEquivalentes: [this.centro?.habitantesEquivalentes],
    });

    this.centroDesignData.emit(this.myDesignForm);

    this.myDesignForm.valueChanges.subscribe(() => {
      this.getFormStatus();
      this.centroDesignData.emit(this.myDesignForm);
    });
  }

  getFormStatus() {
    this.countControls = 0;
    this.countFilled = 0;

    Object.keys(this.myDesignForm.controls).forEach((controlName) => {
      const control = this.myDesignForm.get(controlName);

      const controlElement = document.querySelector(
        `[formControlName="${controlName}"]`
      );

      if (controlElement) {
        const hasHiddenClass =
          controlElement.parentElement.classList.contains("hidden");

        if (!hasHiddenClass) {
          this.countControls++;

          if (control?.value !== null && control?.value !== "") {
            this.countFilled++;
          }
        }
      }
    });

    if (this.countFilled !== 0) {
      this.designFormComplete.emit(this.countControls === this.countFilled);
    }
  }
}
